import { APPLICATIONS } from '@/services/consts/application';

const VM_MIDDLEWARES = {
  auth: null,
  permission: 'MY_VISITORS',
  document: { applicationId: APPLICATIONS.APP_VISITOR.id },
  //   menuPreferences: "MY_VISITORS"
};

export default {
  path: '/my-visitors',
  name: 'r_my-visitors',
  meta: {
    middlewares: VM_MIDDLEWARES,
  },
  component: () => import('../../components/visitor-management/VisitorManagement'),
  children: [
    {
      path: ':receptionDeskId',
      name: 'r_my-visitors-reception-desk',
      meta: {
        middlewares: VM_MIDDLEWARES,
      },
      props: {
        backLinkName: 'r_my-visitors',
      },
      component: () => import('../../components/visitor-management/ReceptionDesk'),
      children: [
        {
          path: 'add-visitor',
          name: 'r_my-visitors-reception-desk-add-visitor',
          meta: {
            middlewares: VM_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_my-visitors-reception-desk',
          },
          component: () => import('../../components/visitor-management/AddVisitor'),
          children: [
            {
              path: 'host',
              name: 'r_my-visitors-reception-desk-add-visitor-select-host',
              meta: {
                middlewares: VM_MIDDLEWARES,
              },
              props: {
                actionType: 'add',
                backLinkName: 'r_my-visitors-reception-desk-add-visitor',
              },
              component: () => import('../../components/visitor-management/SelectHost'),
            },
            {
              path: 'language',
              name: 'r_my-visitors-reception-desk-add-visitor-select-language',
              meta: {
                middlewares: VM_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_my-visitors-reception-desk-add-visitor',
              },
              component: () => import('../../components/visitor-management/SelectLanguage'),
            },
            {
              path: 'containers',
              name: 'r_my-visitors-reception-desk-add-containers-to-visitor',
              meta: {
                middlewares: VM_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_my-visitors-reception-desk-add-visitor',
              },
              component: () =>
                import('../../components/visitor-management/AddAssignableContainersToVisitor'),
            },
          ],
        },
        {
          path: ':visitorId',
          name: 'r_my-visitors-reception-desk-edit-visitor',
          meta: {
            middlewares: VM_MIDDLEWARES,
          },
          props: {
            backLinkName: 'r_my-visitors-reception-desk',
          },
          component: () => import('../../components/visitor-management/EditVisitor'),
          children: [
            {
              path: 'visits',
              name: 'r_my-visitors-reception-desk-edit-visitor-visits',
              meta: {
                middlewares: VM_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_my-visitors-reception-desk-edit-visitor',
              },
              component: () => import('../../components/visitor-management/Visit/Visits'),
              children: [
                {
                  path: ':visitId',
                  name: 'r_my-visitors-reception-desk-edit-visitor-edit-visit',
                  meta: {
                    middlewares: VM_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_my-visitors-reception-desk-edit-visitor-visits',
                  },
                  component: () => import('../../components/visitor-management/Visit/Visit'),
                  children: [
                    {
                      path: 'host',
                      name: 'r_my-visitors-reception-desk-edit-visit-select-host',
                      meta: {
                        middlewares: VM_MIDDLEWARES,
                      },
                      props: {
                        actionType: 'add',
                        backLinkName: 'r_my-visitors-reception-desk-edit-visitor-edit-visit',
                      },
                      component: () => import('../../components/visitor-management/SelectHost'),
                    },
                  ],
                },
                {
                  path: 'add',
                  name: 'r_my-visitors-reception-desk-edit-visitor-add-visit',
                  meta: {
                    middlewares: VM_MIDDLEWARES,
                  },
                  props: {
                    backLinkName: 'r_my-visitors-reception-desk-edit-visitor-visits',
                  },
                  component: () => import('../../components/visitor-management/Visit/AddVisit'),
                  children: [
                    {
                      path: 'host',
                      name: 'r_my-visitors-reception-desk-add-visit-select-host',
                      meta: {
                        middlewares: VM_MIDDLEWARES,
                      },
                      props: {
                        actionType: 'add',
                        backLinkName: 'r_my-visitors-reception-desk-edit-visitor-add-visit',
                      },
                      component: () => import('../../components/visitor-management/SelectHost'),
                    },
                  ],
                },
              ],
            },
            {
              path: 'language',
              name: 'r_my-visitors-reception-desk-edit-visitor-select-language',
              meta: {
                middlewares: VM_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_my-visitors-reception-desk-edit-visitor',
              },
              component: () => import('../../components/visitor-management/SelectLanguage'),
            },
            {
              path: 'containers',
              name: 'r_my-visitors-reception-desk-edit-add-containers-to-visitor',
              meta: {
                middlewares: VM_MIDDLEWARES,
              },
              props: {
                backLinkName: 'r_my-visitors-reception-desk-edit-visitor',
              },
              component: () =>
                import('../../components/visitor-management/AddAssignableContainersToVisitor'),
            },
          ],
        },
      ],
    },
  ],
};
